const MarkOkIcon = (props: any) => (
  <svg
    width={12}
    height={12}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
    // style={{ transform: "scale(1.3)" }}
  >
    <g filter="url(#a)">
      <circle cx={6} cy={6} r={6} fill={props.color} style={{ transitionDuration: "0.3s" }}/>
    </g>
    <path
      d="m3.53 6.53.977 1.107a1 1 0 0 0 1.488.012L8.47 4.941"
      stroke="#fff"
      strokeLinecap="round"
    />
    <defs>
      <filter
        id="a"
        x={-3}
        y={-3}
        width={18}
        height={18}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feGaussianBlur in="BackgroundImageFix" stdDeviation={1.5} />
        <feComposite
          in2="SourceAlpha"
          operator="in"
          result="effect1_backgroundBlur_1826_49819"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_backgroundBlur_1826_49819"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);

export default MarkOkIcon;
